import { AssortmentItemMinimal } from '@retail/my-assortment/types';
import BulkEditSelectedItemsDialog from './BulkEditSelectedItemsDialog';
import { useAssortmentItemsActions } from '@retail/my-assortment/context';

interface Props {
  selectedItems: AssortmentItemMinimal[];
  resetCheckedItems: () => void;
  onClose: () => void;
}

export function BulkEditItemsDialogContainer({ selectedItems, resetCheckedItems, onClose }: Props) {
  const { addItemsToAssortment } = useAssortmentItemsActions();

  return (
    <BulkEditSelectedItemsDialog
      open
      action="edit"
      selectedItems={selectedItems}
      addItemsToAssortment={addItemsToAssortment}
      onClose={onClose}
      resetCheckedItems={resetCheckedItems}
    />
  );
}
